import React, { useRef } from 'react';
import './error.css';
import { KID_1 } from '../../utils/constants/images';
import { useNavigate } from 'react-router-dom';
import BestStartButton from '../../components/button';

function SomethingWrongPage(props) {
    const navigate = useNavigate();
    const didNavigateRef = useRef(false);

    const handleBack = () => {
        if (didNavigateRef.current) return;
        didNavigateRef.current = true;

        if (typeof props?.onReset === 'function') {
            try { props.onReset(); } catch (e) { /* ignore */ }
        }

        setTimeout(() => {
            try {
                if (window.history.length > 1) {
                    navigate(-1);
                } else {
                    navigate('/');
                }
            } catch (e) {
                window.location.href = '/';
            }
        }, 50);
    };

    return (
        <div className="error-container">
            <img src={KID_1} alt="Error" className="error-image" />
            <h1>Something went wrong</h1>
            <p>An error occurred on this page. Please contact BestStart helpdesk.</p>
            <div className="error-actions">
                <BestStartButton text="Go back" color="blue" onClick={handleBack} data-testid="error-back" />
            </div>
        </div>
    );
}

export default SomethingWrongPage;
